import React from 'react';

import { BottomDrawer, DrawerContentSecondary } from 'uiToolkitV1/BottomDrawer';

import { useBulkActionContext } from '../BulkActions/BulkActionContext';
import EmployeesList from './EmployeesList';
import { PARTIAL_PUBLISH_SCREENS, usePartialPublishContext } from './PartialPublishContext';
import PublishOptions from './PublishOptions';
import Result from './Result';
import './agGrid.css';

const ShareResultsDrawer = () => {
  const { screen, isOpen, resetState } = usePartialPublishContext();
  const { resetSelection } = useBulkActionContext();

  const componentMapping = {
    [PARTIAL_PUBLISH_SCREENS.PUBLISH_OPTIONS]: PublishOptions,
    [PARTIAL_PUBLISH_SCREENS.EMPLOYEES_LIST]: EmployeesList,
    [PARTIAL_PUBLISH_SCREENS.RESULT]: Result,
  };

  const Child = componentMapping[screen];

  const onClose = () => {
    resetState();
    resetSelection();
  };

  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose}>
      <DrawerContentSecondary>
        <Child onClose={onClose} />
      </DrawerContentSecondary>
    </BottomDrawer>
  );
};

export default ShareResultsDrawer;
